module.exports = __webpack_public_path__ + "assets/discount_mobile-cd49a8.svg";